// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.jpg";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import laravel from "./assets/techstack/laravel.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
// Porject Images
import projectImage1 from "./assets/projects/project1.jpg";
import projectImage2 from "./assets/projects/project2.jpg";
import projectImage3 from "./assets/projects/project3.jpg";
import projectImage4 from "./assets/projects/project4.jpg";
import projectImage5 from "./assets/projects/project5.jpg";
import projectImage6 from "./assets/projects/project6.jpg";

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Muhammed Ahmed",
  tagline: "I build things for the web: powerful backends, secure networks, and clean designs.",
  img: profile,
  about: `I am a backend developer who builds scalable web applications with secure and reliable systems.
My background as a network administrator strengthens the performance and safety of every project.
Blending in my skills as a graphic designer, I deliver solutions that are both functional and visually engaging.`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/muhammed-ahmed-170a40276/",
  github: "https://github.com/muhammednoorrr",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "IT Support & Graphic Designer",
    Company: `Local NGO`,
    Location: "Addis Ababa, Ethiopia",
    Type: "Full Time",
    Duration: "Aug 2025 - now",
  },
  {
    Position: "Backend Developer Intern",
    Company: `PerfoNet Technologies`,
    Location: "Addis Ababa, Ethiopia",
    Type: "Internship",
    Duration: "Feb 2025 - Apr 2025",
  },
  {
    Position: "Network Administrator Intern",
    Company: `BahirDar Incubation CenterS`,
    Location: "BahirDar, Ethiopia",
    Type: "Internship",
    Duration: "Jun 2024 - Sept 2024",
  },
  {
    Position: "Scoial Media Manager & Host",
    Company: `Techet`,
    Location: "Addis Ababa, Ethiopia",
    Type: "Volunteer",
    Duration: "Dec 2025 - Apr 2025",
  },
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Bachelors in Information Systems",
    Company: `Addis Ababa University`,
    Location: "Addis Ababa",
    Type: "Full Time",
    Duration: "May 2022 - June 2025S",
  },
  {
    Position: "Backend Development",
    Company: "ALX Africa",
    Location: "Online",
    Type: "Online",
    Duration: "Mar 2025 - Present",
  },
  {
    Position: "Certified Cisco Network Administrator",
    Company: "Cisco",
    Location: "Online",
    Type: "Online",
    Duration: "Dec 2023 - Apr 2024",
  },
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  laravel: laravel,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "AAU Ecommerce Website",
    image: projectImage1,
    description: `Developed a fully functional e-commerce website for Addis Ababa University using HTML, CSS, and JavaScript.
The project featured product listings, a shopping cart system, and a responsive design to enhance user experience.`,
    techstack: "HTML/CSS, JavaScript",
    previewLink: "https://aau-electronics-shop.vercel.app/shop.html",
    githubLink: "https://github.com/muhammednoorrr/AAU-Electronics-Shop",
  },
  {
    title: "CCNA Projects",
    image: projectImage2,
    description: `Completed hands-on CCNA lab training, building and configuring networks using routers, switches, and Packet Tracer. Gained practical skills in routing, switching, and troubleshooting to strengthen my foundation in networking.`,
    techstack: "Cisco Packet Tracer",
    previewLink: "",
    githubLink: "https://github.com/muhammednoorrr/CCNA-lab",
  },
  {
    title: "Chess Game",
    image: projectImage3,
    description: `Built an ongoing chess game project in C#, implementing core gameplay features such as move validation, turn management, and check/checkmate logic. Currently enhancing the user interface and refining gameplay for a complete experience.`,
    techstack: "C#",
    previewLink: "",
    githubLink: "https://github.com/muhammednoorrr/Chess-Game-Project",
  },
  {
    title: "Snake Game",
    image: projectImage4,
    description: `Built a simple Snake game with JavaScript for fun, focusing on movement and basic gameplay. A small project that helped me practice logic and interactivity on the web.`,
    techstack: "HTML/CSS, JavaScript",
    previewLink: "https://snake-game-seven-steel.vercel.app/",
    githubLink: "https://github.com/muhammednoorrr/snake-game",
  },
  {
    title: "Task-Managegment-System",
    image: projectImage5,
    description: `Designed and built a Task Management System with staff registration, manager dashboards, and role-based access control.
The system streamlines task assignment, tracking, and administration, improving coordination between staff and management.`,
    techstack: "C#",
    previewLink: "",
    githubLink: "https://github.com/muhammednoorrr/Task-Managegment-System",
  },
  {
    title: "Pizza Shop Website",
    image: projectImage6,
    description: `Created a static Pizza Shop website showcasing a rich menu, talented chefs, and an easy table-booking feature.
Designed to highlight offerings and enhance customer engagement with a simple, attractive layout.`,
    techstack: "HTML/CSS, SCSS",
    previewLink: "https://pizza-shop-w.vercel.app/",
    githubLink: "https://github.com/muhammednoorrr/Pizza-Shop-W",
  },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "muhamme7d7@gmail.com",
  phone: "+251 984253737",
};
